import React from "react";
import { Link } from "gatsby";

const usefulLinks = [
  { text: "Property Valuation in London", url: "/contact/property-valuation" },
  { text: "Sell", url: "/sell/" },
  { text: "Landlords", url: "/let/" },
  { text: "Property Management in London", url: "/property-management/" },
  { text: "Block Management in London", url: "/block-management/" },
  { text: "Properties for Sale in London", url: "/property/for-sale/in-kensington-and-chelsea/" },
  { text: "Properties to Rent in London", url: "/property/to-rent/in-kensington-and-chelsea/" },
];

const UsefulLinks = () => {
  return (
    <div className="footer-useful-links">
      <h3>Useful Links</h3>
      <ul>
        {usefulLinks.map((link, index) => (
          <li key={index}>
            <Link to={link.url}>{link.text}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default UsefulLinks;